<template>
    <v-container>
        <h1>Grades</h1>
        <!-- <p>{{ this.terms }}</p> -->
        <div class="typography" v-if="this.$store.state.status === 'fetch_success'">
            <h3>{{ this.course_title }} ({{ this.$route.params.id }})</h3>
        <div class="table_wrapper">
            <div class="table_wrapper_inner">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>ID</th>
                            <th>Grades</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="student in this.student_array" v-bind:key="student.student_id">
                            <td width="45%">{{ student.first_name }} {{ student.last_name }}</td>
                            <td width="10%">{{ student.student_id }}</td>
                            <td width="45%" v-if="student.final_grade === null">
                                <v-select :value="student.grade" :items="grades" item-value="value" item-text="label" no-data-text="Select Grade" placeholder="Select Grade" clearable @input="handleSelect(student, $event)"></v-select>
                            </td>
                            <td width="45%" v-else>
                                {{ student.final_grade }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
         <a href="#" v-if="this.grades_finalized === false" @click="this.submitGrades" class="secondary-button">Submit Grades</a>
        <hr style="height: 1px; background-color: #ffb500; border:none; margin-top: 20px; margin-bottom: 20px;" />
        <p>All enrolled students must have their final grades submitted at the same time. Once submitted, grades cannot be changed within this dashboard. If you would like to change any submitted grades please contact us at <a href="mailto:ccap@adelphi.edu">ccap@adelphi.edu.</a></p>
        </div>
        <div v-else>
            <v-skeleton-loader
            class="mx-auto"
            type="table-body, table-row-divider@6"
            ></v-skeleton-loader>
        </div>
       
        <v-snackbar v-model="modal_display">
            Your information has been saved.
            <v-btn @click="modal_display = false">Close</v-btn>
        </v-snackbar>

        <v-dialog v-model="confirmation" max-width="500">
            <v-card v-if="this.grades_submitting === false">
                <v-card-title>
                Confirm Your Grade Submission
                </v-card-title>

                <v-card-text>
                Please ensure all grades are correct. No changes can be made after submitting.
                </v-card-text>

                <v-card-actions>
                   <v-spacer></v-spacer>
                   <button @click="confirmation=false">Go Back</button>
                   <button @click="confirmGradeSubmission()">Agree</button>
                        <!-- <v-btn
                            color="red darken-1"
                            text
                            @click="confirmation = false"
                        >
                            Disagree
                        </v-btn>
                        <v-btn
                            color="green darken-1"
                            text
                            @click="confirmation = false"
                        >
                            Agree
                        </v-btn> -->
                </v-card-actions>
            </v-card>
            <v-card v-else>
                <v-card-title>
                    Submitting final grades
                </v-card-title>
                <v-card-text align="center">
                     <Preloader />
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>

</template>


<script>

import axios from 'axios'
import Preloader from './Preloader'
export default {
    components: {
        Preloader
    },
    data: () => ({
        student_array: [],
        course_title: '',
        course_term: '',
        grades_submitting: false,
        grades_finalized: true,
        grades: [
            {'label': 'A+ (100 - 97)', 'value': 'A+'},
            {'label': 'A (96 - 94)', 'value': 'A'},
            {'label': 'A- (93 - 90)', 'value': 'A-'},
            {'label': 'B+ (89 - 87)', 'value': 'B+'},
            {'label': 'B (86 - 84)', 'value': 'B'},
            {'label': 'B- (83 - 80)', 'value': 'B-'},
            {'label': 'C+ (79 - 77)', 'value': 'C+'},
            {'label': 'C (76 - 74)', 'value': 'C'},
            {'label': 'C- (73 - 70)', 'value': 'C-'},
            {'label': 'D (69 - 65)', 'value': 'D'},
            {'label': 'F (65 or below)', 'value': 'F'},
        ],
        payload: null,
        modal_display: false,
        confirmation: false
    }),

    methods: {
        // TODO: Handle submitting grades for realz.
        submitGrades: function() {
            this.$store.dispatch('submitGrades')
                .then((resp) => {
                    this.payload = {instructorUsername: this.username, term: this.course_term, courseId: this.course_id, grades: []}
                    for(let i = 0; i < this.student_array.length; i++) {
                        if (this.student_array[i].grade === '') {   // TODO: Handle this in the UX
                            alert('please fill out all grades')
                            return;
                        }else {
                            this.payload.grades.push({ id: this.student_array[i].student_id, grade: this.student_array[i].grade })
                        }
                    }
                    
                    // axios.post('https://neptune.adelphi.edu/~finkelstein/student-dashboard/remote-apis/post-grade-test.php', payload, { headers: {'Authorization' : `Bearer ${this.token}`}}).then(function(res) {
                    //     window.console.log(res)
                    // })
                    this.confirmation = true
                    // window.console.log(JSON.stringify(this.payload))
                    // alert('Yay!')
                    window.console.log(resp)
                })
        },

        confirmGradeSubmission: function() {
            let self = this
            this.grades_submitting = true
            axios.post('https://class.adelphi.edu/dashboard/remote-apis/post-grade-test.php', this.payload, { headers: {'Authorization' : `Bearer ${this.token}`}}).then(function(res) {
                window.console.log(res)
                self.confirmation = false
                self.modal_display = true
                self.grades_submitting = false
                self.grades_finalized = true
                window.console.log(JSON.stringify(self.payload))
            }).catch(function(err) {
                window.console.error(err)
                self.grades_submitting = false
                self.grades_finalized = false
                self.confirmation = false
                window.alert("There was an error submitting your grades. Please contact ccap@adelphi.edu.")
            })
        },

        handleSelect: function(student, e) {
            window.console.log(e)
            student.grade = e
        }
    },

    mounted() {
        this.$store.dispatch('fetchInstructorRoster')
        .then((resp) => {
                window.console.log("DEETS: "+resp)
                for (var i = 0; i < this.course_rosters.length; i++) {
                    window.console.log(this.course_rosters[i].course_id + ' ' +this.$route.params.id)
                    if (this.course_rosters[i].course_id === this.$route.params.id.split('-')[1] && this.course_rosters[i].term_code === this.$route.params.id.split('-')[0].replace('*', '/')) {
                        // this.student_array = this.course_rosters[i].students
                        let temp_grade_array = []
                        for (let j = 0; j < this.course_rosters[i].students.length; j++) {
                            if (this.course_rosters[i].students[j].final_grade !== null) {
                                temp_grade_array.push(this.course_rosters[i].students[j].final_grade)
                            }
                            this.student_array[j] = this.course_rosters[i].students[j];
                            this.student_array[j].grade = '';
                        }

                        // Only display Submit Grades button if grades have not been previously submitted.
                        if (temp_grade_array.length !== 0) {
                            this.grades_finalized = true
                        }else {
                            this.grades_finalized = false
                        }
                        window.console.log(this.course_rosters[i].title)
                        this.course_title = this.course_rosters[i].title
                        this.course_term = this.course_rosters[i].term_code
                        this.course_id = this.course_rosters[i].course_id
                        
                        window.console.log("String " + JSON.stringify(this.student_array))
                    }
                }
        })

        
    },

    computed: {
        course_rosters: function() {
            return this.$store.getters.course_rosters
        },
        grades_submitted: function() {
            return this.$store.getters.grades_submitted
        },
        token: function() {
            return this.$store.getters.token
        },
        username: function() {
            return this.$store.getters.username
        },
        user_id: function() {
            return this.$store.getters.user_id
        }
    }
}
</script>
